var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6536 13.5542C17.8492 12.9438 17.9549 12.2932 17.9549 11.6178C17.9549 8.11801 15.1177 5.28084 11.6178 5.28084C8.11801 5.28084 5.28084 8.11801 5.28084 11.6178C5.28084 12.2932 5.38647 12.9438 5.58212 13.5542H7.86206C7.5624 12.9741 7.39317 12.3157 7.39317 11.6178C7.39317 9.28462 9.28462 7.39317 11.6178 7.39317C13.951 7.39317 15.8425 9.28462 15.8425 11.6178C15.8425 12.3157 15.6733 12.9741 15.3736 13.5542H17.6536ZM12.674 0H10.5617V3.1685H12.674V0ZM4.14961 2.65597L2.65597 4.14961L4.89644 6.39008L6.39008 4.89644L4.14961 2.65597ZM20.5797 4.14961L19.0861 2.65597L16.8456 4.89644L18.3393 6.39008L20.5797 4.14961ZM20.0672 12.674H23.2357V10.5617H20.0672V12.674ZM3.1685 12.674V10.5617H0V12.674H3.1685Z",
    fill: "#9E9C9D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14.2803,
    width: 23.2357,
    height: 2.17835,
    fill: "#9E9C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunSet);
export default __webpack_public_path__ + "static/media/sun-set.d4f2b3b5a24d21f96912c3939d5dd0af.svg";
export { ForwardRef as ReactComponent };